import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

const stats = [
  { value: "1200+", label: "收录番剧" },
  { value: "18", label: "细分标签" },
  { value: "30+", label: "年份跨度" },
  { value: "9.5", label: "口碑均分" },
];

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const submit = (e: FormEvent) => {
    e.preventDefault();
    navigate(`/sousuo${keyword.trim() ? `?q=${encodeURIComponent(keyword.trim())}` : ""}`);
  };

  return (
    <section className="relative flex min-h-screen w-full items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20collage%20with%20silhouetted%20characters%20walking%20toward%20a%20glowing%20sunset%2C%20floating%20sakura%20petals%20and%20film%20reel%20elements%20in%20the%20sky%2C%20warm%20cream%20and%20deep%20orange%20palette%2C%20artistic%20poster%20design%2C%20cinematic%20cozy%20mood%2C%20high%20detail%20painting&width=1600&height=900&seq=milk-hero&orientation=landscape"
        alt="牛奶动漫库 动漫检索库首屏背景"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 pt-20 text-center md:px-8">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
          <i className="ri-cup-line"></i> 用一杯牛奶的时间，找到今天想看的番
        </span>
        <h1 className="mt-6 font-heading text-4xl font-black leading-tight text-background-50 md:text-6xl">
          牛奶动漫库
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-background-100/90 md:text-lg">
          按年份、评分、标签精准检索番剧，剧场版 / OVA 分区直达，高口碑榜单与隐藏目录一网打尽。告别大海捞针，一秒定位你想看的动漫。
        </p>

        <form
          onSubmit={submit}
          className="mx-auto mt-8 flex w-full max-w-xl flex-col gap-2 rounded-full bg-background-50 p-1.5 shadow-sm sm:flex-row"
        >
          <label htmlFor="hero-search" className="sr-only">
            搜索番剧
          </label>
          <input
            id="hero-search"
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="输入番名、标签或年份，如「神作」"
            className="h-12 flex-1 rounded-full bg-transparent px-4 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="inline-flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line"></i> 立即检索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-2 text-xs text-background-100/80">
          <span className="rounded-full bg-background-50/10 px-3 py-1">热门：神作</span>
          <span className="rounded-full bg-background-50/10 px-3 py-1">剧场版</span>
          <span className="rounded-full bg-background-50/10 px-3 py-1">2024 新番</span>
          <span className="rounded-full bg-background-50/10 px-3 py-1">OVA 番外</span>
        </div>

        <dl className="mx-auto mt-12 grid max-w-2xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg bg-background-50/10 px-4 py-4 backdrop-blur">
              <dt className="text-xs text-background-100/70">{s.label}</dt>
              <dd className="mt-1 font-heading text-2xl font-bold text-accent-400">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2 text-background-100/70">
        <i className="ri-arrow-down-s-line text-2xl animate-bounce"></i>
      </div>
    </section>
  );
}